import {
  Create,
  SimpleForm,
  TextInput,
  required,
  SaveButton,
  Toolbar,
} from "react-admin";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function CreateToolbar() {
  const navigate = useNavigate();
  return (
    <Toolbar sx={{ gap: 1 }}>
      <SaveButton />
      <Button onClick={() => navigate(-1)}>Annulla</Button>
    </Toolbar>
  );
}

export function ProjectCreate() {
  return (
    <Create redirect="list">
      <SimpleForm toolbar={<CreateToolbar />}>
        <TextInput
          source="name"
          label="Nome progetto"
          validate={[required()]}
          fullWidth
        />
        <TextInput
          source="description"
          label="Descrizione"
          multiline
          rows={4}
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
}
